import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, RadioGroup, FormControlLabel, Radio } from '@mui/material';

export default function InsertPageModal({ open, onClose, onInsert }) {
  const [choice, setChoice] = useState('after'); // 'before' | 'after' | 'end'

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Insert Page</DialogTitle>
      <DialogContent dividers>
        <RadioGroup
          value={choice}
          onChange={(e)=>setChoice(e.target.value)}
          name="insert-page-choice"
        >
          <FormControlLabel value="before" control={<Radio />} label="Before current position" />
          <FormControlLabel value="after" control={<Radio />} label="After current position" />
          <FormControlLabel value="end" control={<Radio />} label="At end of document" />
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={()=>onInsert(choice)}>Insert</Button>
      </DialogActions>
    </Dialog>
  );
}
